import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Badge,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { brandColors } from '../../theme';
import IdeaCard from './IdeaCard';
import type { Idea } from '../../types/ideaBoard';

interface CategoryGroupProps {
  category: string;
  ideas: Idea[];
  isAdmin?: boolean;
}

const CategoryGroup: React.FC<CategoryGroupProps> = ({ category, ideas, isAdmin = false }) => {
  return (
    <Accordion
      defaultExpanded
      disableGutters
      sx={{
        mb: 2,
        border: `1px solid`,
        borderColor: 'divider',
        borderRadius: '8px !important',
        boxShadow: 'none',
        '&:before': { display: 'none' },
        '&.Mui-expanded': { margin: '0 0 16px 0' },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          borderRadius: '8px',
          backgroundColor: `${brandColors.blue}08`,
          '&.Mui-expanded': {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
          },
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 600, color: brandColors.indigo }}
          >
            {category}
          </Typography>
          <Badge
            badgeContent={ideas.length}
            color="primary"
            sx={{
              '& .MuiBadge-badge': {
                position: 'static',
                transform: 'none',
                backgroundColor: brandColors.blue,
                color: '#fff',
                fontSize: '0.7rem',
                height: 20,
                minWidth: 20,
                borderRadius: 10,
              },
            }}
          />
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 2 }}>
        {ideas.map((idea) => (
          <IdeaCard key={idea.id} idea={idea} isAdmin={isAdmin} />
        ))}
      </AccordionDetails>
    </Accordion>
  );
};

export default CategoryGroup;
